/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useMerchantsReviews from "./useMerchantsReviews";
import MerchantReviewCard from "./MerchantReviewCard";
import MerchantSliderControls from "./MerchantSliderControls";
import { COLORS } from "./merchants.constants";

export default function MerchantsSay() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || "https://madar-api.madar.iq/api").replace(/\/+$/, '');


  const { reviews, loading } = useMerchantsReviews(baseUrl);
  const [currentReview, setCurrentReview] = useState(0);

  const current = reviews[currentReview] || {};

  const handlePrev = () =>
    setCurrentReview((p) => (p === 0 ? reviews.length - 1 : p - 1));
  const handleNext = () =>
    setCurrentReview((p) => (p === reviews.length - 1 ? 0 : p + 1));

  useEffect(() => {
    if (reviews.length > 0 && currentReview >= reviews.length) {
      setCurrentReview(0);
    }
  }, [reviews.length, currentReview]);

  return (
    <section
      className="py-5"
      style={{
        background: COLORS.gradient,
        direction: isArabic ? "rtl" : "ltr",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
        textAlign: "center",
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-5"
          style={{
            color: COLORS.gold,
            fontSize: "2.4rem",
            fontFamily: "'Cairo', sans-serif",
          }}
        >
          {t("merchants.title")}
        </h2>

        {loading ? (
          <div className="text-center py-5">
            <div
              className="spinner-border"
              role="status"
              style={{ color: COLORS.gold }}
            />
          </div>
        ) : reviews.length === 0 ? (
          <p style={{ opacity: 0.8 }}>
            {isArabic
              ? "لا توجد آراء متاحة حالياً"
              : "No reviews available at the moment"}
          </p>
        ) : (
          <div
            className="position-relative mx-auto p-4 rounded-4"
            style={{
              maxWidth: 850,
              background: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.15)",
            }}
          >
            <MerchantSliderControls
              isArabic={isArabic}
              onPrev={handlePrev}
              onNext={handleNext}
            />

            <MerchantReviewCard current={current} />
          </div>
        )}
      </div>
    </section>
  );
}
